import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { PersonalChangeRequestsByMember } from "../../../@types/changeRequests.types";

const { get } = request;

const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "change-request";

export const getPersonalChangeRequests = async (
	query: Record<string, unknown>
): Promise<PersonalChangeRequestsByMember[]> => {
	try {
		const endpoint = `${initialRoute}/personal`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		if (err.response.status === 400) {
			const { message } = err.response.data;
			alert(message);
		} else {
			alert(err);
		}
		throw err;
	}
};

export const personalChange = {
	getPersonalChangeRequests
};
